import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { lazy, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { siteConfig } from "./config/site";

import weekOfYear from 'dayjs/plugin/weekOfYear'
import advancedFormat from "dayjs/plugin/advancedFormat"
import MainLayout from './layout/MainLayout';
import IAAMLogin from './IAAMLogin';
import UserPermissionPage from './pages/UserPermission/UserPermissionPage';
import { ThemeProvider, createTheme } from '@mui/material/styles';


dayjs.extend(advancedFormat)
dayjs.extend(weekOfYear)

const CaseReportPage = lazy(() => import("./pages/CaseReport/CaseReportPage"))
const LarvalReportPage = lazy(() => import("./pages/LarvalReport/LarvalReportPage"))
const ContainerReportPage = lazy(() => import("./pages/ContainerReport/ContainerReportPage"))
const ExecutionResultPage = lazy(() => import("./pages/ExecutionResult/ExecutionResultPage"))
const NotFoundPage = lazy(() => import("./pages/NotFound/NotFoundPage"))

const SettingContext = React.createContext()

const THRESHOLD = 160;
let devtoolsOpen = false;
let checkInterval = null;

function showConsoleWarning() {
    // หัวข้อใหญ่ สีแดง
    console.log(
        "%cหยุดก่อน-STOP!",
        "font-size:40px; color: red; font-weight: 900; text-shadow: 1px 1px 0 #000;"
    );

    // รายละเอียดเพิ่มเติม (block style)
    const titleStyle = "font-size:14px; font-weight:bold; padding:8px 0;";
    const boxStyle =
        "font-size:12px; line-height:1.4; padding:12px; border-left:4px solid red; background: #fff7f7; color:#333; max-width:600px;";
    console.log(
        "%c⚠️ คำเตือนเกี่ยวกับการละเมิดสิทธิ์การเข้าถึงข้อมูล ⚠️ \nหากคุณกำลังพยายามเข้าถึง API หรือข้อมูลที่อยู่ภายใต้การคุ้มครองสิทธิ์ของระบบ การเข้าถึงหรือใช้งานข้อมูลเหล่านี้โดยไม่ได้รับอนุญาต ถือเป็นการละเมิดความเป็นเจ้าของข้อมูล และอาจมีผลทางกฎหมายตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล (PDPA) และกฎหมายอื่นที่เกี่ยวข้อง \nหากคุณเป็นนักพัฒนา โปรดใช้ API หรือข้อมูลภายใต้ช่องทางที่ได้รับอนุญาตเท่านั้น หากคุณไม่ได้รับสิทธิ์ โปรดหยุดการกระทำนี้ทันที",
        titleStyle + boxStyle
    );

    // console.log(
    //     "%c⚠️ Unauthorized Access Warning ⚠️ \nIf you are attempting to access APIs or data that are protected by ownership and privacy laws. Unauthorized access, use, or disclosure of this data may constitute a violation of data protection laws (including PDPA and related regulations). \nIf you are a developer, please use only authorized endpoints or developer credentials. If you do not have permission, cease this activity immediately.",
    //     titleStyle + boxStyle
    // );
}

// เริ่มตรวจทุก 500ms
checkInterval = setInterval(checkDevTools, 500);

// ทำความสะอาดเมื่อ unload (ไม่จำเป็นแต่ดี)
window.addEventListener("beforeunload", function () {
    clearInterval(checkInterval);
});

function checkDevTools() {
    // วิธีตรวจจับโดยใช้ความต่าง outer - inner ขนาดหน้าต่าง (works in many desktop browsers)
    const widthDiff = window.outerWidth - window.innerWidth;
    const heightDiff = window.outerHeight - window.innerHeight;
    const open = widthDiff > THRESHOLD || heightDiff > THRESHOLD;

    if (open && !devtoolsOpen) {
        devtoolsOpen = true;
        showConsoleWarning();
    } else if (!open && devtoolsOpen) {
        devtoolsOpen = false;
        // ถ้าต้องการ log เมื่อปิด ก็ทำได้:
        console.log("[INFO] DevTools closed.");
    }
}

const reducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            let _setting = JSON.parse(localStorage.getItem('trb.setting'))
            if(_setting && !_setting.display.hasOwnProperty("is_healht_org")){
                _setting = undefined;
            }
            let isUserApproved = false
            // console.log(action.isPermited)
            const profile = action.profile
            if (profile) {
                if (profile?.userApproved !== undefined) {
                    isUserApproved = profile.userApproved === "true" ? true : false
                    const isHealhtOrg = profile.org_type === "01";
                    if (!_setting || !_setting.case_count?.time_range) {
                        let area_profile = "TH"
                        switch (profile.org_level) {
                            case "02":
                                area_profile = "DPC"
                                break
                            case "03":
                                area_profile = "PROV"
                                break
                            case "04":
                                area_profile = "AMPHUR"
                                break
                            case "05":
                                area_profile = "TAMBON"
                                break
                            default:
                                area_profile = "TH"

                        }
                        _setting = {
                            case_count: {
                                view: "area",
                                area: {
                                    data: "cumulative",
                                },
                                time: {
                                    data: "continuous",
                                },
                                time_range: {
                                    selected: "W",
                                    W: {
                                        start: dayjs().format('YYYY-ww'),
                                        end: dayjs().format('YYYY-ww')
                                    },
                                    M: {
                                        start: dayjs().format('YYYY-MM'),
                                        end: dayjs().format('YYYY-MM')
                                    },
                                },
                                comparison: {
                                    time_range: {
                                        selected: "W",
                                        W: {
                                            start: Number(dayjs().format('ww')).toString(),
                                            end: Number(dayjs().format('ww')).toString()
                                        },
                                        M: {
                                            start: dayjs().format('MM'),
                                            end: dayjs().format('MM')
                                        }
                                    },
                                    years: [Number(dayjs().format('YYYY')).toString()]
                                }
                            },
                            time_range: {
                                selected: "W",
                                W: {
                                    start: dayjs().format('YYYY-ww'),
                                    end: dayjs().format('YYYY-ww')
                                },
                                M: {
                                    start: dayjs().format('YYYY-MM'),
                                    end: dayjs().format('YYYY-MM')
                                },
                            },
                            display: {
                                selected: isHealhtOrg ? "area" : "org",
                                is_healht_org: isHealhtOrg,
                                area: {
                                    selected: area_profile,
                                    TH: "TH",
                                    TH_NAME: "ประเทศไทย",
                                    DPC: profile.dpc_code,
                                    DPC_NAME: profile.dpc_name,
                                    PROV: profile.province_code,
                                    PROV_NAME: profile.province_name,
                                    AMPHUR: profile.amphur_code,
                                    AMPHUR_NAME: profile.amphur_name,
                                    TAMBON: profile.tambon_code,
                                    TAMBON_NAME: profile.tambon_name,
                                },
                                org: {
                                    selected: profile.org_id,
                                    name: profile.org_name
                                }
                            },
                        }
                    }
                }
                else {
                    window.location.href = `${process.env.REACT_APP_IAAMREG_HOST}`
                }
            }
            localStorage.setItem('trb.setting', JSON.stringify(_setting));
            return {
                ...state,
                // isPermited: action.isPermited,
                isAuthenticated: true,
                isUserApproved: isUserApproved,
                setting: _setting,
                profile: profile,
                iaam: action.iaam
            };
        case "LOGOUT":
            return {
                ...state,
                isAuthenticated: false,
                isUserApproved: false,
                setting: null,
                profile: null
            };
        case "ON_PAGE_CHANGE":
            return {
                ...state,
                page_selected: action.payload.page_selected
            };
        case "SUBMIT_SETTING":
            return {
                ...state,
                setting: action.payload
            };
        default:
            return state;
    }
};

const theme = createTheme({
    typography: {
        fontFamily: [
            'Noto Sans Thai',
        ].join(','),
    },
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    "&&.Mui-selected": {
                        backgroundColor: "#b73238",
                        color: "#fff"
                    },
                    "&&.MuiMenuItem-root:hover": {
                        backgroundColor: "#ffebee",
                        color: "#000"
                    }
                }
            }
        },
        // MuiAutocomplete: {
        //     styleOverrides: {
        //         listbox: {
        //             '& .MuiAutocomplete-option.Mui-focused': { 
        //                 backgroundColor: '#ffebee',
        //                 // color: "#000"
        //             },
        //             '& .MuiAutocomplete-option[aria-selected="true"]': { 
        //                 backgroundColor: '#ffebee',
        //                 // color: "#fff"
        //             },
        //             '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': { 
        //                 backgroundColor: '#ffebee',
        //                 // color: "#fff"
        //             }
        //         },
        //     }g
        // },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    "&&.Mui-checked": {
                        color: "#b73238"
                    }
                }
            }
        },
        MuiPickersYear: {
            styleOverrides: {
                yearButton: {
                    "&&.Mui-selected": {
                        backgroundColor: "#b73238",
                        color: "#fff"
                    },
                }
            }
        },
        MuiPickersMonth: {
            styleOverrides: {
                monthButton: {
                    "&&.Mui-selected": {
                        backgroundColor: "#b73238",
                        color: "#fff"
                    },
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                switchBase: {
                    "&&.Mui-checked": {
                        color: "#b73238",
                        "&&+.MuiSwitch-track": {
                            backgroundColor: "#b73238"
                        },
                    },

                }
            }
        }
    }
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path="/" element={<NavWrapper />} >
                        <Route path="/" element={<LarvalReportPage />} />
                        <Route path="/case" element={<CaseReportPage />} />
                        <Route path="/larval" element={<LarvalReportPage />} />
                        <Route path="/container" element={<ContainerReportPage />} />
                        <Route path="/execution" element={<ExecutionResultPage />} />
                        <Route path="/*" element={<NotFoundPage />} />
                    </Route>
                </Routes>
            </Router>
        </ThemeProvider>
    );
}

function NavWrapper() {
    const location = useLocation();
    const initialState = {
        isAuthenticated: false,
        isPermited: true,
        page_selected: location.pathname === "/" ? "larval" : location.pathname.split("/")[1],
        setting: null
    };

    const [state, dispatch] = React.useReducer(reducer, initialState);
    const [setting, setSetting] = useState(null);
    const [allowedRoutes, setAllowedRoutes] = useState(null);

    const routeComponents = {
        larval: <LarvalReportPage />,
        case: <CaseReportPage />,
        container: <ContainerReportPage />,
        execution: <ExecutionResultPage />
    };

    useEffect(() => {
        if(state.isAuthenticated){
            const allowedRoutes = siteConfig.pageItems
            .filter(({ org_type }) => org_type.includes(state.profile?.org_type))
            .map(({ key }) => key);
            setAllowedRoutes(allowedRoutes)
        }
    }, [state])

    return (
        <SettingContext.Provider value={{ state, dispatch, setting, setSetting }}>
            {!state.isAuthenticated ? (
                <IAAMLogin />
            ) : state.isPermited && state.isUserApproved ? (
                    <MainLayout />
            ) : (
                <UserPermissionPage />

            )}
        </SettingContext.Provider>
    )
}
export { SettingContext }

export default App;
